import {Component} from '@angular/core';
import {DiscoverpeopleService} from '../discover/discover.service';
import { Router } from '@angular/router';
@Component({
    selector: 'discover',
    template: require('.//discover.component.html'),
    providers: [DiscoverpeopleService]
    // directives: [HeaderComponent, FooterComponent]
})

export class DiscoverComponent {

    private loading = true;
    private data: any =[];
    private offset = 0;
    private loadmoree:any;
    // private buffer = false;
    constructor(private _discoverService: DiscoverpeopleService, private _router: Router) {

    }

    ngOnInit() {
        var token = localStorage.getItem('authToken');
        if (!token)
            this._router.navigate(["login"]);

        this._discoverService.discoverpeople()
            .subscribe((res) => {
                this.data = res.discoverData;
                this.offset = this.data.length;
                this.loading = false;
                 if (this.offset >= 20)
                    this.loadmoree = true;
            });
    }
     loadmore() {
        this.offset = this.data.length;
        //console.log(this.offset);
        this._discoverService.loadmore(this.offset)
            .subscribe((res) => {
                var len = res.discoverData.length;
                 for (var i = 0; i < len; i++) {
                    this.data.push(res.discoverData[i]);
                    }                
                this.offset = res.discoverData.length || 0;
                if (this.offset >= 20)
                    this.loadmoree = true;
                else
                    this.loadmoree = false;
            });
    }

    memberprofile(username: any): void {
        // alert(item.postsId);
        var personname = username.toLowerCase();
       var currentusername = localStorage.getItem('username');
       if(currentusername == personname){
            this._router.navigate(['home/profile']);
            }
            else{
                let link = ['home/person', personname];
                this._router.navigate(link);
            }        
        // let link = ['home/person', username.toLowerCase()];
        // this._router.navigate(link);
    }

    following(username: any, i: number) {
        // alert(i+'ll'+username+'ff'+followFlag);
        //  this.buffer = true;
         var privateProfile = this.data[i].privateProfile;
        // //console.log(privateProfile);
        if(privateProfile == 1){
            this.data[i].loaderFlag = true;      
            setTimeout(() => {        
                this.data[i].followsFlag = 2;
            }, 500);       
            this._discoverService.following(username)
                .subscribe();       
            setTimeout(() => {
                this.data[i].loaderFlag = false;
            }, 500);    

        }else{
            this.data[i].loaderFlag = true;      
            setTimeout(() => {        
                this.data[i].followsFlag = 1;
            }, 500);       
            this._discoverService.following(username)
                .subscribe();       
            setTimeout(() => {
                this.data[i].loaderFlag = false;
            }, 500); 
        }         
    }

    follow(username: any, i: number) {        
        this.data[i].loaderFlag = true; 
        setTimeout(() => {     
         this.data[i].followsFlag = 0;
         }, 500);          
        this._discoverService.follow(username)
            .subscribe();
        setTimeout(() => {
            this.data[i].loaderFlag = false;
        }, 500);      
       
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Home/discover/discover.component.ts
 **/